import { ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";
import { MaterialGradeType } from "shared";

export type ProcessStepCatalogDto = ClientInferResponseBody<
  typeof contract.quoteRequestLines.getProcessStepCatalog
>;

export const fetchProcessStepCatalog = async (payload: {
  materialGrade: MaterialGradeType;
}): Promise<ProcessStepCatalogDto | null> => {
  const response = await api.quoteRequestLines.getProcessStepCatalog.query({
    query: payload,
  });

  if (response.status === 200) {
    return response.body;
  }

  return null;
};
